import AreaTipoDivergenciaEnum from '../../AreaTipoDivergenciaEnum';
import { useBuildFinalStepTemplate } from '../../template/FinalStepTemplate';
import useBuildSubmitHandler from '../../template/UseBuildSubmitHandler';
import TipoDivergenciasKey from '../../TipoDivergenciasKey';
import { TipoDivergenciaComponent } from '../../TiposDeDivergencias';


const EstampariaSemProcesso: TipoDivergenciaComponent = ({
  onBack,
  onSetStep,
}) => {


  const key = TipoDivergenciasKey.ESTAMPARIA_SEM_PROCESSO;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);


  return useBuildFinalStepTemplate({

    area: AreaTipoDivergenciaEnum.ESTAMPARIA,
    loading: loadingSave || loadingTipoDivergencia,
    onBack,
    onSetStep: handleSubmit,
    tipoDivergencia: 'Itens que necessitam de estampa sem o processo realizado, ou não conforme.',
  });

};

export default EstampariaSemProcesso;
